import React from 'react';
import './values.scss';

const Values = () => {
  const valuesData = [
    {
      letter: "W",
      title: "Willing",
      description: "Committed to your growth, every step of the way."
    },
    {
      letter: "A",
      title: "Agile",
      description: "Adapting to your needs in a fast-changing world."
    },
    {
      letter: "T",
      title: "Trustworthy",
      description: "Displaying expertise and integrity every day."
    },
    {
      letter: "C",
      title: "Curious",
      description: "Fuelling curiosity, driving innovation."
    },
    {
      letter: "H",
      title: "Helpful",
      description: "Guiding you to success with expert support."
    },
    {
      letter: "E",
      title: "Excellent",
      description: "Setting the standard for world-class training."
    },
    {
      letter: "L",
      title: "Learner-centred",
      description: "Your learning, your journey, our focus."
    },
    {
      letter: "M",
      title: "Mastery",
      description: "Turning knowledge into mastery."
    }
  ];

  // Split values into two rows: WATCH and ELM
  const topRowValues = valuesData.slice(0, 5);
  const bottomRowValues = valuesData.slice(5);

  return (
    <div className="values-container">
      <div className="values-header">
        <h2>Our Values<span className="dot">.</span></h2>
        <p className="values-description">
          At WatchElm, our values form the foundation of everything we do. We're committed to excellence in 
          technical education through a collaborative, supportive approach that puts your success at the center.
        </p>
      </div>

      <div className="values-grid">
        <div className="values-row">
          {topRowValues.map((value, index) => (
            <div className="value-item" key={`top-${index}`}>
              <div className="value-letter">{value.letter}</div>
              <div className="value-divider"></div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
        
        <div className="values-row bottom-row">
          {bottomRowValues.map((value, index) => (
            <div className="value-item" key={`bottom-${index}`}>
              <div className="value-letter">{value.letter}</div>
              <div className="value-divider"></div>
              <h3 className="value-title">{value.title}</h3>
              <p className="value-description">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Values;
